import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { BulkSignedUrlPayload } from 'Interfaces/Common';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: BulkSignedUrlPayload) =>
    $actions.user.getEmbedSignedUrlBulk(dispatch, payload),
  );
};
